import './stylus/app.styl'
import MilNodeComponents from './components/MilNode'
import Components from './components'

const MilNode = {
  install (Vue, args) {
    Vue.use(MilNodeComponents, {
      Components,
      ...args
    })
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(MilNode)
}

export default MilNode
